import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { AssociateBillingMethodRequestPayload } from '@/models/ps-management/multi-methods.model';

export default class AssociateBillingMethodListRequest extends ApiResourceMethod<{}> {
  public perform(payload: AssociateBillingMethodRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `${payload.multiMethodId}/billingPaymentMethod`,
        data: payload.payloadData,
      },
      (payload: BaseResponse<{}>) => {
        return payload.data;
      },
    );
  }
}
